<div class="confirmation">
  <div class="confirmation-header">
    {{ "auth.confirmation.title" | translate }}
  </div>
  <div class="confirmation-description">
    @switch (loginType()) {
      @case (0) {
        {{ "auth.confirmation.description_mail" | translate }} {{ payload() }}
      }
      @case (1) {
        {{
          "auth.confirmation.description_phone" | translate: {phone: payload()}
        }}
      }
      @default {
        {{ "auth.confirmation.description_unknown" | translate }} {{ payload() }}
      }
    }
  </div>
  @if (codeError || errorMessage) {
    <div class="errorBlock">
      {{ errorMessage?.message }}
      <!--      @if (attempts === 0) {-->
      <!--        {{ "auth.confirmation.noAttempts" | translate }}-->
      <!--      } @else {-->
      <!--        {{ "auth.confirmation.wrongCode" | translate }}-->
      <!--        {{ "auth.confirmation.youHave" | translate }} {{ attempts }}-->
      <!--        {{-->
      <!--          attempts === 1-->
      <!--            ? ("auth.confirmation.attempt" | translate)-->
      <!--            : ("auth.confirmation.attempts" | translate)-->
      <!--        }}-->
      <!--      }-->
    </div>
  }
  <div class="otp-wrapper">
    <p-inputOtp
      [(ngModel)]="code"
      (input)="setCode()"
      class="otp"
      [length]="loginType() ? 5 : 4"
      [integerOnly]="true"
      type="number"
    >
    </p-inputOtp>
  </div>
  @if (!is_recovery()) {
    <mat-checkbox class="checkbox-text" [(ngModel)]="short_session">
      {{ "auth.withPassword.foreignComputer" | translate }}
    </mat-checkbox>
  }
  @if (loginType()) {
    <button (click)="showNewTel()" class="newtel-btn">
      {{ "auth.confirmation.other" | translate }}
    </button>
  }
  <button
    class="btn btn-send"
    (click)="sendCode()"
    [disabled]="
      (loginType() && code.length < 5) ||
      (!loginType() && code.length < 4) ||
      !has_attempts
    "
  >
    {{ "auth.confirmation.send" | translate }}
  </button>
  <button class="btn btn-resend" (click)="resendCode()" [disabled]="resend">
    @if (resend) {
      {{ "auth.confirmation.resend_timer" | translate }} {{ timer }}
      {{ "auth.confirmation.resend_sec" | translate }}
    } @else {
      {{ "auth.confirmation.resend" | translate }}
    }
  </button>
</div>
